export const userPath = "/user";
export const partnerPath = "/partner";

export const PATH = {
  Home: "/",
  GamePage: "/:category/:provider",
  ProviderPage: "/:category",
  Promotion: "/promotion",
  AboutUs: "/about-us",
  ContactUs: "/contact-us",
  Privacy: "/privacy",
  Rule: "/rule",
  FAQ: "/FAQ",

  Disclaimer: "/disclaimer",
  Partner: "/partner",
  ResponsibleGambling: "/responsible-gambling",
  PartnerAgent: {
    home: "/partner",
    aboutUs: partnerPath + "AboutUs",
  },
  User: {
    userPage: userPath,
    Profile: userPath + "/profile",
    Deposit: userPath + "/deposit",
    Withdraw: userPath + "/withdraw",
    SecuritySetting: userPath + "/security-setting",
    Notifications: userPath + "/notifications",
    Announcement: userPath + "/announcement",
    InternalMail: userPath + "/internal-mail",
    Event: userPath + "/event",
    Transactions: userPath + "/transactions",
    BettingHistory: userPath + "/betting-history",
    Refund: userPath + "/refund",
    FavouriteGame: userPath + "/favourite-game",
    Financial: userPath + "/financial",
    TransactionHistory: userPath + "/transaction-history",
    Notification: userPath + "/Announcement",
    MemberVipDetail: "/vipDetails",
    MemberVip: userPath + "/Vip",
    changePasswordWithdraw: userPath + "/changePassword",
    HistoryUpdateVip: userPath + "/VipGradeRecord",
    AwardVip: userPath + "/VipRewardList",
  },
  Account: {
    login: "/account/login",
    register: "/account/register",
    forgetPassword: "/account/forget-password",
    forgotPassword: "/account/forgot-password",
  },
};
